import { supabase } from '@/lib/supabase';
import type {
  PositionsInsert,
  PositionsRow,
  PositionsUpdate,
} from '@/types/database.types';

export async function listPositions(): Promise<PositionsRow[]> {
  const { data, error } = await supabase
    .from('positions')
    .select('*')
    .order('sort_order', { ascending: true })
    .order('name', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function createPosition(
  input: PositionsInsert,
): Promise<PositionsRow> {
  const { data, error } = await supabase
    .from('positions')
    .insert(input)
    .select('*')
    .single();
  if (error) throw error;
  return data;
}

export async function updatePosition(
  id: string,
  patch: PositionsUpdate,
): Promise<PositionsRow> {
  const { data, error } = await supabase
    .from('positions')
    .update(patch)
    .eq('id', id)
    .select('*')
    .single();
  if (error) throw error;
  return data;
}

export async function deletePosition(id: string): Promise<void> {
  const { error } = await supabase.from('positions').delete().eq('id', id);
  if (error) throw error;
}
